/* tslint:disable */
/* eslint-disable */
/**
 * After-Hours Access Request API
 * API for office building tenants to request after-hours access for specific dates/times. Backend: Node.js. Frontend: React.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AccessRequest
 */
export interface AccessRequest {
    /**
     * 
     * @type {string}
     * @memberof AccessRequest
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AccessRequest
     */
    'buildingId': string;
    /**
     * 
     * @type {string}
     * @memberof AccessRequest
     */
    'floorId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccessRequest
     */
    'tenantId': string;
    /**
     * 
     * @type {string}
     * @memberof AccessRequest
     */
    'requesterUserId': string;
    /**
     * Start date/time as epoch timestamp in milliseconds
     * @type {number}
     * @memberof AccessRequest
     */
    'startDateTime': number;
    /**
     * End date/time as epoch timestamp in milliseconds
     * @type {number}
     * @memberof AccessRequest
     */
    'endDateTime': number;
    /**
     * IANA timezone for display/auditing
     * @type {string}
     * @memberof AccessRequest
     */
    'timezone'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AccessRequest
     */
    'areas'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AccessRequest
     */
    'reason'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccessRequest
     */
    'status': AccessRequestStatusEnum;
    /**
     * 
     * @type {AccessRequestDecision}
     * @memberof AccessRequest
     */
    'decision'?: AccessRequestDecision | null;
    /**
     * Creation timestamp as epoch milliseconds
     * @type {number}
     * @memberof AccessRequest
     */
    'createdAt': number;
    /**
     * Last update timestamp as epoch milliseconds
     * @type {number}
     * @memberof AccessRequest
     */
    'updatedAt': number;
}

export const AccessRequestStatusEnum = {
    Pending: 'PENDING',
    Approved: 'APPROVED',
    Denied: 'DENIED',
    Cancelled: 'CANCELLED'
} as const;

export type AccessRequestStatusEnum = typeof AccessRequestStatusEnum[keyof typeof AccessRequestStatusEnum];

/**
 * 
 * @export
 * @interface AccessRequestDecision
 */
export interface AccessRequestDecision {
    /**
     * 
     * @type {string}
     * @memberof AccessRequestDecision
     */
    'decidedByUserId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestDecision
     */
    'decidedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestDecision
     */
    'decisionNote'?: string;
}
/**
 * 
 * @export
 * @interface CancelBody
 */
export interface CancelBody {
    /**
     * 
     * @type {string}
     * @memberof CancelBody
     */
    'reason'?: string;
}
/**
 * 
 * @export
 * @interface DecisionBody
 */
export interface DecisionBody {
    /**
     * 
     * @type {string}
     * @memberof DecisionBody
     */
    'decisionNote'?: string;
}
/**
 * 
 * @export
 * @interface ListAccessRequests200Response
 */
export interface ListAccessRequests200Response {
    /**
     * 
     * @type {Array<AccessRequest>}
     * @memberof ListAccessRequests200Response
     */
    'data': Array<AccessRequest>;
    /**
     * 
     * @type {PaginationMeta}
     * @memberof ListAccessRequests200Response
     */
    'meta': PaginationMeta;
}
/**
 * 
 * @export
 * @interface ModelError
 */
export interface ModelError {
    /**
     * 
     * @type {string}
     * @memberof ModelError
     */
    'error': string;
    /**
     * 
     * @type {string}
     * @memberof ModelError
     */
    'message': string;
    /**
     * 
     * @type {string}
     * @memberof ModelError
     */
    'code'?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ModelError
     */
    'details'?: { [key: string]: any; };
}
/**
 * 
 * @export
 * @interface NewAccessRequest
 */
export interface NewAccessRequest {
    /**
     * 
     * @type {string}
     * @memberof NewAccessRequest
     */
    'buildingId': string;
    /**
     * 
     * @type {string}
     * @memberof NewAccessRequest
     */
    'floorId'?: string;
    /**
     * 
     * @type {string}
     * @memberof NewAccessRequest
     */
    'requesterUserId': string;
    /**
     * Start date/time as epoch timestamp in milliseconds
     * @type {number}
     * @memberof NewAccessRequest
     */
    'startDateTime': number;
    /**
     * End date/time as epoch timestamp in milliseconds
     * @type {number}
     * @memberof NewAccessRequest
     */
    'endDateTime': number;
    /**
     * 
     * @type {string}
     * @memberof NewAccessRequest
     */
    'timezone'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof NewAccessRequest
     */
    'areas'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof NewAccessRequest
     */
    'reason'?: string;
}
/**
 * 
 * @export
 * @interface PaginationMeta
 */
export interface PaginationMeta {
    /**
     * 
     * @type {number}
     * @memberof PaginationMeta
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationMeta
     */
    'pageSize': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationMeta
     */
    'totalItems': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationMeta
     */
    'totalPages': number;
}
/**
 * 
 * @export
 * @interface TimetableResponse
 */
export interface TimetableResponse {
    /**
     * 
     * @type {boolean}
     * @memberof TimetableResponse
     */
    'hasActive': boolean;
    /**
     * 
     * @type {number}
     * @memberof TimetableResponse
     */
    'count': number;
    /**
     * 
     * @type {Array<AccessRequest>}
     * @memberof TimetableResponse
     */
    'data'?: Array<AccessRequest>;
    /**
     * 
     * @type {TimetableResponseWindow}
     * @memberof TimetableResponse
     */
    'window': TimetableResponseWindow;
}
/**
 * 
 * @export
 * @interface TimetableResponseWindow
 */
export interface TimetableResponseWindow {
    /**
     * 
     * @type {string}
     * @memberof TimetableResponseWindow
     */
    'from': string;
    /**
     * 
     * @type {string}
     * @memberof TimetableResponseWindow
     */
    'to': string;
}
/**
 * Only allowed while status is PENDING
 * @export
 * @interface UpdateAccessRequest
 */
export interface UpdateAccessRequest {
    /**
     * Start date/time as epoch timestamp in milliseconds
     * @type {number}
     * @memberof UpdateAccessRequest
     */
    'startDateTime'?: number;
    /**
     * End date/time as epoch timestamp in milliseconds
     * @type {number}
     * @memberof UpdateAccessRequest
     */
    'endDateTime'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateAccessRequest
     */
    'timezone'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateAccessRequest
     */
    'areas'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UpdateAccessRequest
     */
    'reason'?: string;
}

/**
 * AccessRequestsApi - axios parameter creator
 * @export
 */
export const AccessRequestsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Approve a pending request
         * @param {string} requestId Identifier of the access request
         * @param {DecisionBody} [decisionBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveAccessRequest: async (requestId: string, decisionBody?: DecisionBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestId' is not null or undefined
            assertParamExists('approveAccessRequest', 'requestId', requestId)
            const localVarPath = `/requests/{requestId}/approve`
                .replace(`{${"requestId"}}`, encodeURIComponent(String(requestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(decisionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Cancel a request
         * @param {string} requestId Identifier of the access request
         * @param {CancelBody} [cancelBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelAccessRequest: async (requestId: string, cancelBody?: CancelBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestId' is not null or undefined
            assertParamExists('cancelAccessRequest', 'requestId', requestId)
            const localVarPath = `/requests/{requestId}/cancel`
                .replace(`{${"requestId"}}`, encodeURIComponent(String(requestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cancelBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new after-hours access request
         * @param {NewAccessRequest} newAccessRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccessRequest: async (newAccessRequest: NewAccessRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'newAccessRequest' is not null or undefined
            assertParamExists('createAccessRequest', 'newAccessRequest', newAccessRequest)
            const localVarPath = `/requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(newAccessRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete an access request (Admin only)
         * @param {string} requestId Identifier of the access request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccessRequest: async (requestId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestId' is not null or undefined
            assertParamExists('deleteAccessRequest', 'requestId', requestId)
            const localVarPath = `/requests/{requestId}/cancel`
                .replace(`{${"requestId"}}`, encodeURIComponent(String(requestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deny a pending request
         * @param {string} requestId Identifier of the access request
         * @param {DecisionBody} decisionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        denyAccessRequest: async (requestId: string, decisionBody: DecisionBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestId' is not null or undefined
            assertParamExists('denyAccessRequest', 'requestId', requestId)
            // verify required parameter 'decisionBody' is not null or undefined
            assertParamExists('denyAccessRequest', 'decisionBody', decisionBody)
            const localVarPath = `/requests/{requestId}/deny`
                .replace(`{${"requestId"}}`, encodeURIComponent(String(requestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(decisionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a specific access request
         * @param {string} requestId Identifier of the access request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessRequest: async (requestId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestId' is not null or undefined
            assertParamExists('getAccessRequest', 'requestId', requestId)
            const localVarPath = `/requests/{requestId}`
                .replace(`{${"requestId"}}`, encodeURIComponent(String(requestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns whether there are any APPROVED requests overlapping the given time window for a building. If no window is provided, defaults to the next 24 hours starting at the beginning of the current hour (UTC).
         * @summary Check active after-hours requests for a building
         * @param {string} [buildingId] 
         * @param {number} [from] Filter requests with startDateTime &gt;&#x3D; from (epoch ms)
         * @param {number} [to] Filter requests with endDateTime &lt;&#x3D; to (epoch ms)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimetable: async (buildingId?: string, from?: number, to?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/timetable`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (buildingId !== undefined) {
                localVarQueryParameter['buildingId'] = buildingId;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = to;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List access requests
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [sort] 
         * @param {string} [buildingId] 
         * @param {string} [floorId] 
         * @param {string} [tenantId] 
         * @param {ListAccessRequestsStatusEnum} [status] 
         * @param {number} [from] Filter requests with startDateTime &gt;&#x3D; from (epoch ms)
         * @param {number} [to] Filter requests with endDateTime &lt;&#x3D; to (epoch ms)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAccessRequests: async (page?: number, pageSize?: number, sort?: string, buildingId?: string, floorId?: string, tenantId?: string, status?: ListAccessRequestsStatusEnum, from?: number, to?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (buildingId !== undefined) {
                localVarQueryParameter['buildingId'] = buildingId;
            }

            if (floorId !== undefined) {
                localVarQueryParameter['floorId'] = floorId;
            }

            if (tenantId !== undefined) {
                localVarQueryParameter['tenantId'] = tenantId;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = to;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a pending access request
         * @param {string} requestId Identifier of the access request
         * @param {UpdateAccessRequest} updateAccessRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAccessRequest: async (requestId: string, updateAccessRequest: UpdateAccessRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestId' is not null or undefined
            assertParamExists('updateAccessRequest', 'requestId', requestId)
            // verify required parameter 'updateAccessRequest' is not null or undefined
            assertParamExists('updateAccessRequest', 'updateAccessRequest', updateAccessRequest)
            const localVarPath = `/requests/{requestId}`
                .replace(`{${"requestId"}}`, encodeURIComponent(String(requestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAccessRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AccessRequestsApi - functional programming interface
 * @export
 */
export const AccessRequestsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AccessRequestsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Approve a pending request
         * @param {string} requestId Identifier of the access request
         * @param {DecisionBody} [decisionBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async approveAccessRequest(requestId: string, decisionBody?: DecisionBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessRequest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.approveAccessRequest(requestId, decisionBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccessRequestsApi.approveAccessRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Cancel a request
         * @param {string} requestId Identifier of the access request
         * @param {CancelBody} [cancelBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelAccessRequest(requestId: string, cancelBody?: CancelBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessRequest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelAccessRequest(requestId, cancelBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccessRequestsApi.cancelAccessRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a new after-hours access request
         * @param {NewAccessRequest} newAccessRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAccessRequest(newAccessRequest: NewAccessRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessRequest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAccessRequest(newAccessRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccessRequestsApi.createAccessRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete an access request (Admin only)
         * @param {string} requestId Identifier of the access request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAccessRequest(requestId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAccessRequest(requestId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccessRequestsApi.deleteAccessRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Deny a pending request
         * @param {string} requestId Identifier of the access request
         * @param {DecisionBody} decisionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async denyAccessRequest(requestId: string, decisionBody: DecisionBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessRequest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.denyAccessRequest(requestId, decisionBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccessRequestsApi.denyAccessRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a specific access request
         * @param {string} requestId Identifier of the access request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccessRequest(requestId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessRequest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccessRequest(requestId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccessRequestsApi.getAccessRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns whether there are any APPROVED requests overlapping the given time window for a building. If no window is provided, defaults to the next 24 hours starting at the beginning of the current hour (UTC).
         * @summary Check active after-hours requests for a building
         * @param {string} [buildingId] 
         * @param {number} [from] Filter requests with startDateTime &gt;&#x3D; from (epoch ms)
         * @param {number} [to] Filter requests with endDateTime &lt;&#x3D; to (epoch ms)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTimetable(buildingId?: string, from?: number, to?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimetableResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTimetable(buildingId, from, to, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccessRequestsApi.getTimetable']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List access requests
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [sort] 
         * @param {string} [buildingId] 
         * @param {string} [floorId] 
         * @param {string} [tenantId] 
         * @param {ListAccessRequestsStatusEnum} [status] 
         * @param {number} [from] Filter requests with startDateTime &gt;&#x3D; from (epoch ms)
         * @param {number} [to] Filter requests with endDateTime &lt;&#x3D; to (epoch ms)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAccessRequests(page?: number, pageSize?: number, sort?: string, buildingId?: string, floorId?: string, tenantId?: string, status?: ListAccessRequestsStatusEnum, from?: number, to?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListAccessRequests200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAccessRequests(page, pageSize, sort, buildingId, floorId, tenantId, status, from, to, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccessRequestsApi.listAccessRequests']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a pending access request
         * @param {string} requestId Identifier of the access request
         * @param {UpdateAccessRequest} updateAccessRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAccessRequest(requestId: string, updateAccessRequest: UpdateAccessRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessRequest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAccessRequest(requestId, updateAccessRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccessRequestsApi.updateAccessRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AccessRequestsApi - factory interface
 * @export
 */
export const AccessRequestsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AccessRequestsApiFp(configuration)
    return {
        /**
         * 
         * @summary Approve a pending request
         * @param {string} requestId Identifier of the access request
         * @param {DecisionBody} [decisionBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveAccessRequest(requestId: string, decisionBody?: DecisionBody, options?: RawAxiosRequestConfig): AxiosPromise<AccessRequest> {
            return localVarFp.approveAccessRequest(requestId, decisionBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Cancel a request
         * @param {string} requestId Identifier of the access request
         * @param {CancelBody} [cancelBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelAccessRequest(requestId: string, cancelBody?: CancelBody, options?: RawAxiosRequestConfig): AxiosPromise<AccessRequest> {
            return localVarFp.cancelAccessRequest(requestId, cancelBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new after-hours access request
         * @param {NewAccessRequest} newAccessRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccessRequest(newAccessRequest: NewAccessRequest, options?: RawAxiosRequestConfig): AxiosPromise<AccessRequest> {
            return localVarFp.createAccessRequest(newAccessRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete an access request (Admin only)
         * @param {string} requestId Identifier of the access request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccessRequest(requestId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteAccessRequest(requestId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deny a pending request
         * @param {string} requestId Identifier of the access request
         * @param {DecisionBody} decisionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        denyAccessRequest(requestId: string, decisionBody: DecisionBody, options?: RawAxiosRequestConfig): AxiosPromise<AccessRequest> {
            return localVarFp.denyAccessRequest(requestId, decisionBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a specific access request
         * @param {string} requestId Identifier of the access request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessRequest(requestId: string, options?: RawAxiosRequestConfig): AxiosPromise<AccessRequest> {
            return localVarFp.getAccessRequest(requestId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns whether there are any APPROVED requests overlapping the given time window for a building. If no window is provided, defaults to the next 24 hours starting at the beginning of the current hour (UTC).
         * @summary Check active after-hours requests for a building
         * @param {string} [buildingId] 
         * @param {number} [from] Filter requests with startDateTime &gt;&#x3D; from (epoch ms)
         * @param {number} [to] Filter requests with endDateTime &lt;&#x3D; to (epoch ms)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimetable(buildingId?: string, from?: number, to?: number, options?: RawAxiosRequestConfig): AxiosPromise<TimetableResponse> {
            return localVarFp.getTimetable(buildingId, from, to, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List access requests
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [sort] 
         * @param {string} [buildingId] 
         * @param {string} [floorId] 
         * @param {string} [tenantId] 
         * @param {ListAccessRequestsStatusEnum} [status] 
         * @param {number} [from] Filter requests with startDateTime &gt;&#x3D; from (epoch ms)
         * @param {number} [to] Filter requests with endDateTime &lt;&#x3D; to (epoch ms)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAccessRequests(page?: number, pageSize?: number, sort?: string, buildingId?: string, floorId?: string, tenantId?: string, status?: ListAccessRequestsStatusEnum, from?: number, to?: number, options?: RawAxiosRequestConfig): AxiosPromise<ListAccessRequests200Response> {
            return localVarFp.listAccessRequests(page, pageSize, sort, buildingId, floorId, tenantId, status, from, to, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a pending access request
         * @param {string} requestId Identifier of the access request
         * @param {UpdateAccessRequest} updateAccessRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAccessRequest(requestId: string, updateAccessRequest: UpdateAccessRequest, options?: RawAxiosRequestConfig): AxiosPromise<AccessRequest> {
            return localVarFp.updateAccessRequest(requestId, updateAccessRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AccessRequestsApi - object-oriented interface
 * @export
 * @class AccessRequestsApi
 * @extends {BaseAPI}
 */
export class AccessRequestsApi extends BaseAPI {
    /**
     * 
     * @summary Approve a pending request
     * @param {string} requestId Identifier of the access request
     * @param {DecisionBody} [decisionBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessRequestsApi
     */
    public approveAccessRequest(requestId: string, decisionBody?: DecisionBody, options?: RawAxiosRequestConfig) {
        return AccessRequestsApiFp(this.configuration).approveAccessRequest(requestId, decisionBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Cancel a request
     * @param {string} requestId Identifier of the access request
     * @param {CancelBody} [cancelBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessRequestsApi
     */
    public cancelAccessRequest(requestId: string, cancelBody?: CancelBody, options?: RawAxiosRequestConfig) {
        return AccessRequestsApiFp(this.configuration).cancelAccessRequest(requestId, cancelBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new after-hours access request
     * @param {NewAccessRequest} newAccessRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessRequestsApi
     */
    public createAccessRequest(newAccessRequest: NewAccessRequest, options?: RawAxiosRequestConfig) {
        return AccessRequestsApiFp(this.configuration).createAccessRequest(newAccessRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete an access request (Admin only)
     * @param {string} requestId Identifier of the access request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessRequestsApi
     */
    public deleteAccessRequest(requestId: string, options?: RawAxiosRequestConfig) {
        return AccessRequestsApiFp(this.configuration).deleteAccessRequest(requestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deny a pending request
     * @param {string} requestId Identifier of the access request
     * @param {DecisionBody} decisionBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessRequestsApi
     */
    public denyAccessRequest(requestId: string, decisionBody: DecisionBody, options?: RawAxiosRequestConfig) {
        return AccessRequestsApiFp(this.configuration).denyAccessRequest(requestId, decisionBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a specific access request
     * @param {string} requestId Identifier of the access request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessRequestsApi
     */
    public getAccessRequest(requestId: string, options?: RawAxiosRequestConfig) {
        return AccessRequestsApiFp(this.configuration).getAccessRequest(requestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns whether there are any APPROVED requests overlapping the given time window for a building. If no window is provided, defaults to the next 24 hours starting at the beginning of the current hour (UTC).
     * @summary Check active after-hours requests for a building
     * @param {string} [buildingId] 
     * @param {number} [from] Filter requests with startDateTime &gt;&#x3D; from (epoch ms)
     * @param {number} [to] Filter requests with endDateTime &lt;&#x3D; to (epoch ms)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessRequestsApi
     */
    public getTimetable(buildingId?: string, from?: number, to?: number, options?: RawAxiosRequestConfig) {
        return AccessRequestsApiFp(this.configuration).getTimetable(buildingId, from, to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List access requests
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {string} [sort] 
     * @param {string} [buildingId] 
     * @param {string} [floorId] 
     * @param {string} [tenantId] 
     * @param {ListAccessRequestsStatusEnum} [status] 
     * @param {number} [from] Filter requests with startDateTime &gt;&#x3D; from (epoch ms)
     * @param {number} [to] Filter requests with endDateTime &lt;&#x3D; to (epoch ms)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessRequestsApi
     */
    public listAccessRequests(page?: number, pageSize?: number, sort?: string, buildingId?: string, floorId?: string, tenantId?: string, status?: ListAccessRequestsStatusEnum, from?: number, to?: number, options?: RawAxiosRequestConfig) {
        return AccessRequestsApiFp(this.configuration).listAccessRequests(page, pageSize, sort, buildingId, floorId, tenantId, status, from, to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a pending access request
     * @param {string} requestId Identifier of the access request
     * @param {UpdateAccessRequest} updateAccessRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessRequestsApi
     */
    public updateAccessRequest(requestId: string, updateAccessRequest: UpdateAccessRequest, options?: RawAxiosRequestConfig) {
        return AccessRequestsApiFp(this.configuration).updateAccessRequest(requestId, updateAccessRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ListAccessRequestsStatusEnum = {
    Pending: 'PENDING',
    Approved: 'APPROVED',
    Denied: 'DENIED',
    Cancelled: 'CANCELLED'
} as const;
export type ListAccessRequestsStatusEnum = typeof ListAccessRequestsStatusEnum[keyof typeof ListAccessRequestsStatusEnum];


